import React, { useState } from 'react';
import { ReactDrawer } from '../../parts';
import { ResponsiveImage } from '../../parts/ResponsiveImage';

const PremiumInfo = () => {
  const [hasFeedback, setHasFeedback] = useState(false);
  const [showPremiumDrawer, setShowPremiumDrawer] = useState(false);

  const handleClick = () => {
    setShowPremiumDrawer(!showPremiumDrawer);
    if (window.ga) {
      ga('send', 'event', 'premium-info', 'open-drawer');
    }
  };

  const handleFeedback = (value) => () => {
    setHasFeedback(true);
    if (window.ga) {
      ga('send', 'event', 'premium-info', 'feedback', value);
    }
  };

  return (
    <>
      <button type="button" className="button custom-and-premium-toggle" data-layout="small text" onClick={handleClick}>
        <small>Custom & Premium</small>
      </button>
      <ReactDrawer
        className={'layout-big custom-and-premium'}
        showDrawer={showPremiumDrawer}
        setShowDrawer={setShowPremiumDrawer}
        position={'right'}
      >
        <header className="Drawer__header">
          <button
            type="button"
            className="button"
            data-style="navy outline"
            data-layout="noLayout"
            onClick={() => setShowPremiumDrawer(!open)}
            aria-label="Close"
          >
            <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
              <use href="#close"></use>
            </svg>
          </button>
        </header>
        <h2>Wondering why our organizers cost more than others on the market? We get it!</h2>
        <figure className="cover" role="none">
          <ResponsiveImage image={'https://cdn.shopify.com/s/files/1/0585/2282/8966/products/d12aCI10.jpg?v=teste'}></ResponsiveImage>
        </figure>
        <dl>
          <div>
            <dt>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#diamond"></use>
                </svg>
              </figure>
              <h3>Premium Materials</h3>
            </dt>
            <dd>
              <p>
                Buy it for life, not for the moment. Keep flimsy plastic organizers out of the landfill by ordering a custom, high-quality
                product once. Our organizers are made from premium, recyclable, and scratch-resistant acrylic.
              </p>
            </dd>
          </div>
          <div>
            <dt>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#customizable"></use>
                </svg>
              </figure>
              <h3>Completely Customizable</h3>
            </dt>
            <dd>
              <p>
                Transformation is the heartbeat of what we do. We believe custom solutions are the key to unlocking organizational bliss!
                You have complete control over product dimensions and a huge library of user-tested templates to guide your decision.
                Made-for-you comes at a cost, but you can feel confident that when your unique Salt organizer arrives, it will slide
                effortlessly into your drawer and sit snugly in place.
              </p>
            </dd>
          </div>
          <div>
            <dt>
              <figure role="none">
                <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                  <use href="#stunning"></use>
                </svg>
              </figure>
              <h3>Stunning and Practical</h3>
            </dt>
            <dd>
              <p>
                Our crystal-clear acrylic is sleek and sturdy — designed to resist damage, brighten up lackluster spaces and{' '}
                <strong>maximize storage</strong>. We want your neglected drawers to become enjoyable to organize and exciting to open!
              </p>
            </dd>
          </div>
        </dl>
        <div className="feedback-widget">
          <p>Did you find this helpful?</p>
          {hasFeedback ? (
            <p>Thank you!</p>
          ) : (
            <>
              <button onClick={handleFeedback('Helpful')}>Yes</button>
              <button onClick={handleFeedback('Not Helpful')}>No</button>
            </>
          )}
        </div>
      </ReactDrawer>
    </>
  );
};

export default PremiumInfo;
